import {useContext} from 'react'
import ModalContext from '@/components/ModalContext/ModalContext'

const useModal = () => useContext(ModalContext)
export default useModal
